<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
              :spanish="spanish"
              :dataResult='kendo.dataResult'
              :kendo="kendo"
              :loading='isGeneralLoading'
              :selectedField="selectedField"
              @datastatechange='dataStateChange'
              @columnreorder='columnReorder'
              @rowclick='openPath'
              @columnssubmit='onColumnsSubmit'
              @sortchange='sortChange'
              @filterchange='filterChange'
              @selectionchange="onSelectionChange"
              @headerselectionchange="onHeaderSelectionChange"
              >
            </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="getAccionesPosibles !== null && getAccionesPosibles.length > 0 && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in getAccionesPosibles" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('clients.new_client')" icon="plus" @click="goToNewClient" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/ClientsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getClientsPag } from '@/services/clients/getClientsPag'
import { getClientsExcel } from '@/services/clients/getClientsExcel'
import { activateClients } from '@/services/clients/activateClients'
import { i18n } from '@/i18n'
import { process } from '@progress/kendo-data-query'
import KendoGridComponent from '../../components/KendoGridComponent.vue'

export default {
  name: 'list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent
  },
  data: function () {
    return {
      idVista: 8,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('app.clients'),
        icon: 'config',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'clients',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 700, Descripcion: 'Editar campos' },
        { IdAccion: 701, Descripcion: 'Editar personalización' },
        { IdAccion: 800, Descripcion: 'Activar' },
        { IdAccion: 801, Descripcion: 'Desactivar' }
      ],
      processMessage: '¿Estás seguro que deseas borrar los clientes seleccionados?'
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasModuleCustomSMTPCliente']
    },
    hasModuleCustomLogo () {
      return this.$store.getters['auth/hasModuleCustomLogo']
    },
    hasModuleCustomColors () {
      return this.$store.getters['auth/hasModuleCustomColors']
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails']
    },
    getAccionesPosibles () {
      let accionesFinal = []
      if (this.hasSelected) {
        accionesFinal = this.listaAcciones
        if (this.disableTipoLibre) {
          accionesFinal = accionesFinal.filter(x => x.IdAccion !== 800).filter(x => x.IdAccion !== 801)
        } 
        const Distribuidor = this.selected.map(x => x.Distribuidor)[0]
        if (!this.hasModuleCustomSMTPCliente ||
          !this.hasModuleCustomLogo ||
          !this.hasModuleCustomMails ||
          !this.hasModuleCustomColors ||
          !Distribuidor ||
          this.selected.filter(x => x.Distribuidor === Distribuidor).length !== this.selected.length
        ) {
          accionesFinal = accionesFinal.filter(x => x.IdAccion !== 700).filter(x => x.IdAccion !== 701)
        }
      }
      return accionesFinal
    },
    selectIcon: function (IdAccion) {
      return (IdAccion) =>
        IdAccion === 800 ? 'check' 
          : IdAccion === 801 ? 'cross'
            : IdAccion === 700 ? 'editpencil' : 'editpenciladd'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    disableTipoLibre () {
      return (this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') &&
       this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    }
  },
  watch: {
    $route: 'routerChangeHandler',
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
      this.unselect()
    }
  },
  created () {
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    this.data = await this.applyFilters()
  },
  methods: {
    routerChangeHandler: async function () {
      this.filterByParamsData()
      this.initialice()
    },
    initialice: async function () {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      this.data = await this.applyFilters()
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => { 
          if (filter.type === 'clientesCertSAML2PorCaducar') {
            const certificadoSAML2PorCaducar = { label: this.$i18n.t('clients.certificadoSAML2PorCaducar_filter'), value: filter.data }
            filters.certificadoSAML2PorCaducar = certificadoSAML2PorCaducar
          } else if (filter.type === 'clientesCertSAML2Caducados') {
            const certificadoSAML2Caducado = { label: this.$i18n.t('clients.certificadoSAML2Caducado_filter'), value: filter.data }
            filters.certificadoSAML2Caducado = certificadoSAML2Caducado
          } 
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    activateHandler: async function (activateParam) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idClientes: [],
          valor: activateParam,
        }
        for (const element of this.selected) {
          payload.idClientes.push(element.IdEmpresa)
        }
        const response = await activateClients(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 700) {
        const data = { clients: this.selected.map(x => x.IdEmpresa) }
        if (this.role === 'SuperAdministrador') {
          const idDistribuidor = this.selected.map(x => x.idDistribuidor)[0]
          this.$router.push({ name: 'configurations/distributors/template/clients', params: { data: data, id: idDistribuidor } })
        } else {
          this.$router.push({ name: 'configurations/template/clients', params: { data: data } })
        } 
      } else if (this.selectedAction.IdAccion === 701) {
        const data = { clients: this.selected.map(x => x.IdEmpresa) }
        if (this.role === 'SuperAdministrador') {
          const idDistribuidor = this.selected.map(x => x.idDistribuidor)[0]
          this.$router.push({ name: 'configurations/distributors/template/clientspersonalization', params: { data: data, id: idDistribuidor } })
        } else {
          this.$router.push({ name: 'configurations/template/clientspersonalization', params: { data: data } })
        } 
      } else if (this.selectedAction.IdAccion === 800) {
        this.activateHandler(true)
      } else {
        this.activateHandler(false)
      }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    openPath: function (event) {
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Nombre)
      this.$router.push({ name: 'configurations/clients/details', params: { id: event.dataItem.IdEmpresa } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Nombre: data.name ? data.name.value : null,
        emailContacto: data.EmailsContacto ? data.EmailsContacto.value : null,
        CodigoExterno: data.codigoExterno ? data.codigoExterno.value : null,
        NSEmpresa: data.ns ? data.ns.value : null,
        idPartner: data.partner ? data.partner.value : null,
        idGrupoVigilante: data.grupoVigilante ? data.grupoVigilante.value : null,
        idTipoServicio: data.tipoServicio ? data.tipoServicio.value : null,
        Activo: data.activo ? data.activo.value: null,
        organismo: data.organismo ? data.organismo.value : null,
        PendienteFacturacion: data.PendienteFacturacion ? data.PendienteFacturacion.value : null,
        idFaseConfiguracion: data.FaseConfiguracion ? data.FaseConfiguracion.value : null,
        idPaqueteContratacion: data.PaqueteContratacion ? data.PaqueteContratacion.value : null,
        certificadoSAML2Caducado: data.certificadoSAML2Caducado ? data.certificadoSAML2Caducado.value : null,
        certificadoSAML2PorCaducar: data.certificadoSAML2PorCaducar ? data.certificadoSAML2PorCaducar.value : null,
        fechaMigracionSolpheoDesde: data.fechaMigracionSolpheoFrom ? data.fechaMigracionSolpheoFrom.value : null,
        fechaMigracionSolpheoHasta: data.fechaMigracionSolpheoTo ? data.fechaMigracionSolpheoTo.value : null,
        idTipoHSM: data.idTipoHSM ? data.idTipoHSM.value : null,
        idTipoCliente: data.idTipoCliente ? data.idTipoCliente.value : null,
        MaquinasNuestras: data.MaquinasNuestras ? data.MaquinasNuestras.value : null,
        TieneMaquinas: data.TieneMaquinas ? data.TieneMaquinas.value : null,
        TercerosBasico: data.TercerosBasico ? data.TercerosBasico.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IdEmpresa)
        payload.listaIDs = selectedIDs
      }

      // Filtros multiples casos especiales
      payload.codPGNs = data.codPGNMultiple ? data.codPGNMultiple.value : null
      payload.idModulos = data.moduloMultiple ? data.moduloMultiple.value : null

      try {
        const response = await getClientsExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'clientes.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }
      this.dataStateChange({ data: dataState })
    },
    expandChange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Nombre: data.name ? data.name.value : null,
        emailContacto: data.EmailsContacto ? data.EmailsContacto.value : null,
        CodigoExterno: data.codigoExterno ? data.codigoExterno.value : null,
        NSEmpresa: data.ns ? data.ns.value : null,
        idPartner: data.partner ? data.partner.value : null,
        idGrupoVigilante: data.grupoVigilante ? data.grupoVigilante.value : null,
        idTipoServicio: data.tipoServicio ? data.tipoServicio.value : null,
        Activo: data.activo ? data.activo.value: null,
        organismo: data.organismo ? data.organismo.value : null,
        PendienteFacturacion: data.PendienteFacturacion ? data.PendienteFacturacion.value : null,
        idFaseConfiguracion: data.FaseConfiguracion ? data.FaseConfiguracion.value : null,
        idPaqueteContratacion: data.PaqueteContratacion ? data.PaqueteContratacion.value : null,
        certificadoSAML2Caducado: data.certificadoSAML2Caducado ? data.certificadoSAML2Caducado.value : null,
        certificadoSAML2PorCaducar: data.certificadoSAML2PorCaducar ? data.certificadoSAML2PorCaducar.value : null,
        fechaMigracionSolpheoDesde: data.fechaMigracionSolpheoFrom ? data.fechaMigracionSolpheoFrom.value : null,
        fechaMigracionSolpheoHasta: data.fechaMigracionSolpheoTo ? data.fechaMigracionSolpheoTo.value : null,
        idTipoHSM: data.idTipoHSM ? data.idTipoHSM.value : null,
        idTipoCliente: data.idTipoCliente ? data.idTipoCliente.value : null,
        MaquinasNuestras: data.MaquinasNuestras ? data.MaquinasNuestras.value : null,
        TieneMaquinas: data.TieneMaquinas ? data.TieneMaquinas.value : null,
        TercerosBasico: data.TercerosBasico ? data.TercerosBasico.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      // Filtros multiples casos especiales
      objOrder.codPGNs = data.codPGNMultiple ? data.codPGNMultiple.value : null
      objOrder.idModulos = data.moduloMultiple ? data.moduloMultiple.value : null

      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      }
      this.updateAllSelectedHeader()
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      res.respuesta.forEach(x => {
        x.MesesUserPass = x.MesesUserPass === null ? 'Nunca' : x.MesesUserPass + ' meses'
      })
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getClientsPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    goToNewClient: function () {
      this.$router.push({ name: 'configurations/clients/details', params: { id: -1 } })
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
